import { Layout, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

const { Footer } = Layout;
const { Text } = Typography;

const FOOTER_BG = '#0179C1';
const LOGO_SRC = '/bmo-global-asset-management.svg';

/**
 * BMO-branded footer rendered at the bottom of every page. Blue band with the
 * regulatory disclaimer on the left and the BMO Global Asset Management
 * wordmark on the right. Copy is bilingual (sourced from `footer.disclaimer`)
 * to match the rest of the app.
 *
 * Layout uses flex so on narrow viewports the wordmark wraps below the text
 * instead of overflowing — the disclaimer stays readable on every breakpoint.
 */
export function AppFooter() {
  const { t } = useTranslation();
  return (
    <Footer
      style={{
        background: FOOTER_BG,
        padding: '24px 32px',
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 32,
          flexWrap: 'wrap',
          justifyContent: 'space-between',
        }}
      >
        <Text
          style={{
            flex: '1 1 600px',
            fontSize: 12,
            lineHeight: 1.55,
            color: 'rgba(255,255,255,0.92)',
            maxWidth: 920,
          }}
        >
          {t('footer.disclaimer')}
        </Text>
        <img
          src={LOGO_SRC}
          alt="BMO Global Asset Management"
          style={{ height: 28, flexShrink: 0 }}
        />
      </div>
    </Footer>
  );
}
